import { useEffect, useRef } from "react";
import "../styles/AutoResizeTextarea.css";

export default function AutoResizeTextarea({ value, onChange }) {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      id="additional notes"
      name="additional notes"
      className="booking__form--autoTextbox-item-input"
      placeholder="Please add any additional notes..."
      aria-label="additional notes"
      value={value}
      onChange={onChange}
      rows={5}
    />
  );
}
